module.exports = __webpack_public_path__ + "static/media/slideimage-2.0e2c7f59.jpg";